module.exports = Blazy;